import { Stack } from "@mui/material";
import { DayTimeline } from "components/manualReview/DayTimeline/DayTimeline";
import { SafeDateTimePicker } from "components/SafeDateTimePicker";
import { ComponentProps } from "react";
import { DayWindowNavigation } from "./useDayWindowNavigation";

type Props = Readonly<{
  nav: DayWindowNavigation;
  segmentCoverageItems: ComponentProps<
    typeof DayTimeline
  >["segmentCoverageItems"];
  segmentLengthSec: number;
  emphasizeSparseSegments?: boolean;
}>;

// The date picker + day timeline pairing shared by the radio and video panels.
// `heats`/`reviewPeriods`/`ticks` are empty here: these panels reuse the manual
// review timeline purely for segment-coverage scrubbing.
export const DayWindowTimeline = ({
  nav,
  segmentCoverageItems,
  segmentLengthSec,
  emphasizeSparseSegments,
}: Props) => (
  <>
    <Stack direction="row" justifyContent="flex-end" alignItems="center">
      <SafeDateTimePicker
        value={nav.anchorTime}
        onChange={(newValue) => {
          if (newValue) nav.setAnchorTime(newValue);
        }}
        timezone="UTC"
        enableAccessibleFieldDOMStructure={false}
        slotProps={{ textField: { size: "small" } }}
      />
    </Stack>
    <DayTimeline
      viewingWindowStart={nav.windowStart}
      viewingWindowEnd={nav.windowEnd}
      dayStart={nav.dayStart}
      dayEnd={nav.dayEnd}
      heats={[]}
      reviewPeriods={[]}
      ticks={[]}
      onWindowChange={nav.onWindowChange}
      segmentCoverageItems={segmentCoverageItems}
      segmentLengthSec={segmentLengthSec}
      emphasizeSparseSegments={emphasizeSparseSegments}
    />
  </>
);
